export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/TransmissionIcon2.93898a71.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};